import * as React from "react";
const SvgFilters = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M5.83398 8.33594L10.0007 12.5026L14.1673 8.33594H5.83398Z" fill="#6366F1"/>
</svg>
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   width={40}
  //   height={40}
  //   fill="none"
  //   {...props}
  // >
  //   <g clipPath="url(#filters_svg__a)">
  //     <path fill="#fff" d="M-1613-150H307V930h-1920z" />
  //     <path
  //       fill="#6366F1"
  //       d="M31.6 12H8.4a1.2 1.2 0 1 0 0 2.4h23.2a1.2 1.2 0 1 0 0-2.4ZM28 19.6a1.2 1.2 0 0 0-1.2-1.2H13.2a1.2 1.2 0 1 0 0 2.4h13.6a1.2 1.2 0 0 0 1.2-1.2ZM23.2 26a1.2 1.2 0 0 0-1.2-1.2h-4a1.2 1.2 0 1 0 0 2.4h4a1.2 1.2 0 0 0 1.2-1.2Z"
  //     />
  //   </g>
  //   <defs>
  //     <clipPath id="filters_svg__a">
  //       <path fill="#fff" d="M-1613-150H307V930h-1920z" />
  //     </clipPath>
  //   </defs>
  // </svg>
);
export default SvgFilters;